import type { SVGProps } from 'react';

export const FormatItalics = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.3 18.625a.934.934 0 0 1-.65-.25.934.934 0 0 1-.25-.65c0-.25.083-.458.25-.625a.889.889 0 0 1 .65-.275h2.9l3.25-9.65h-2.9a.967.967 0 0 1-.675-.25.934.934 0 0 1-.25-.65c0-.25.083-.458.25-.625a.918.918 0 0 1 .675-.275h7.325c.267 0 .483.092.65.275a.81.81 0 0 1 .275.625.89.89 0 0 1-.275.65.88.88 0 0 1-.65.25h-2.6l-3.225 9.65h2.6a.81.81 0 0 1 .625.275.81.81 0 0 1 .275.625.89.89 0 0 1-.275.65.848.848 0 0 1-.625.25H6.3Z" />
    </svg>
  );
};
